import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import {
  auditLogHeadCells,
  transactionLogHeadCells,
} from "../util/headcells-util";
import _ from "lodash";
import { fetchUserAuditLogs, fetchTransactionAuditLogs } from "../services/logs-service";
import Cookies from "js-cookie";

const Logs = () => {
  const AUDIT_LOG = "Audit Log";
  const TRANSACTION_LOG = "Transaction Log";

  const [alertMessage, setAlertMessage] = useState();
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [logsType, setLogsType] = useState(AUDIT_LOG);
  const [auditLogs, setAuditLogs] = useState(null);
  const [transactionLogs, setTransactionLogs] = useState(null);

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const getUsersAuditLogs = useCallback(async () => {
    let response = await fetchUserAuditLogs(pageNo, recordsPerPage);
    if (response.ok) {
      let data = await response.json();
      if (data.genericList != null) {
        setIsFetchError(false);
        setIsError(false);
        setAuditLogs(data);
      } else {
        setIsFetchError(true);
        setIsError(true);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setIsError(true);
      setAlertMessage(error?.description);
    }
  }, [pageNo, recordsPerPage]);

  const getTransactionAuditLogs = useCallback(async () => {
    let response = await fetchTransactionAuditLogs(pageNo, recordsPerPage);
    if (response.ok) {
      let data = await response.json();
      if (data.genericList != null) {
        setIsFetchError(false);
        setIsError(false);
        setTransactionLogs(data);
      } else {
        setIsFetchError(true);
        setIsError(true);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setIsError(true);
      setAlertMessage(error?.description);
    }
  }, [pageNo, recordsPerPage]);

  useEffect(() => {
    if (logsType === AUDIT_LOG) {
      getUsersAuditLogs();
    } else {
      getTransactionAuditLogs();
    }
  }, [logsType, pageNo, recordsPerPage, getUsersAuditLogs, getTransactionAuditLogs]);

  const buttonsLayout = () => {
    return (
      <div className="flexCenter" style={{ marginLeft: "15px" }}>
        <Form.Group controlId="logs">
          <Form.Select
            className="modalInput generalFont"
            aria-label="Choose Item"
            value={logsType}
            onChange={(e) => {
              setLogsType(e.target.value)
              setPageNo(0)
            }}
          >
            <option value="Audit Log">Audit Log</option>
            <option value="Transaction Log">Transaction Log</option>
          </Form.Select>
        </Form.Group>
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              {logsType === AUDIT_LOG ? AUDIT_LOG : TRANSACTION_LOG}
            </Row>
            <Row className="tableSubtitle generalFont">
              {logsType === AUDIT_LOG
                ? "View all the Actions performed by users of the system"
                : "Detailed log of exceptions that occur between Rules Engine and Salesforce"}
            </Row>
          </Col>
        </Row>
        {isError && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}

        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={
            logsType === AUDIT_LOG ? auditLogHeadCells : transactionLogHeadCells
          }
          rows={
            logsType === AUDIT_LOG
              ? auditLogs?.genericList
              : transactionLogs?.genericList
          }
          pages={
            logsType === AUDIT_LOG
              ? auditLogs?.totalPages
              : transactionLogs?.totalPages
          }
          buttonsLayout={buttonsLayout}
          isLogsScreen={true}
        />
      </Container>
    </>
  );
};

export default Logs;
